<script>
export default {
    name: "Errors",
    props: {
        messages: {
            type: Array,
            required: true
        },
        alertClass: {
            type: String,
            required: false,
            default: 'alert-danger'
        }
    }
}
</script>

<template>
    <div class="alert" :class="alertClass" role="alert" v-if="messages.length">
        <ul class="mb-0">
            <li v-for="message in messages" :key="message">{{ message }}</li>
        </ul>
    </div>
</template>
